// extracted by mini-css-extract-plugin
export var globalHqCard = "styles-module--globalHqCard--d8e0b";